import React from "react";
import { SvgIcon } from "@mui/material";
function CheckIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <svg
        width="22"
        height="18"
        viewBox="0 0 22 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 1.50001C21.9763 2.47632 21.9763 4.05923 21 5.03554L9.26777 16.7678C8.29146 17.7441 6.70855 
          17.7441 5.73224 16.7678L1.00001 12.0355C0.0236951 11.0592 0.0236951 9.47632 1.00001 8.50001C1.97632 7.52369 3.55923 
          7.5237 4.53554 8.50001L7.50001 11.4645L17.4645 1.50001C18.4408 0.523695 20.0237 0.523695 21 1.50001Z"
        />
      </svg>
    </SvgIcon>
  );
}

export default CheckIcon;
